
import { css } from 'lit';
export default css`
:host {
  display: block;
}

.cta-image__wrapper {
  position: relative;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-top: -1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

@media (min-width: 1024px) {

  .cta-image__wrapper {
    margin-left: 0px;
    margin-right: 0px;
  }

  .cta-image__wrapper {
    margin-top: -112px;
  }

  .cta-image__wrapper {
    flex-direction: row;
  }

  .cta-image__wrapper {
    align-items: flex-start;
  }

  .cta-image__wrapper {
    justify-content: flex-start;
  }
}

@media (min-width: 1024px) {

.cta-image__wrapper {
    min-height: 600px;
    padding: 6.25rem 0 0
}
  }

@media print {

.cta-image__wrapper {
    flex-direction: row;
    justify-content: start;
    margin: 0;
    height: 350px
}
  }

.cta-image__wrapper div[slot="image"] {
    width: 100%;
  }

.cta-image__image {
  position: relative;
  top: 0px;
  display: flex;
  width: 100%;
  overflow: hidden;
}

@media (min-width: 640px) {

.cta-image__image {
    max-height: 375px;
  }
  }

@media (min-width: 768px) {

.cta-image__image {
    max-height: 512px;
  }
  }

@media (min-width: 1024px) {

  .cta-image__image {
    position: absolute;
  }

  .cta-image__image {
    z-index: -10;
  }

  .cta-image__image {
    margin-left: 14rem;
  }

  .cta-image__image {
    align-items: center;
  }
}

@media (min-width: 1024px) {

.cta-image__image {
    width: 67vw;
    height: 600px;
    max-height: 600px
}
  }

@media (min-width: 1200px) {

  .cta-image__image {
    height: 100%;
  }
}

@media (min-width: 1366px) {

.cta-image__image {
    width: 97.5%
}
  }

@media print {

.cta-image__image {
    position: absolute;
    z-index: -10;
    align-items: center;
    margin-left: 14rem;
    width: 68vw;
    max-height: 450px;
    height: 350px
}
  }

.cta-image__content {
  position: relative;
  bottom: 0px;
  z-index: 10;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: -5rem;
  display: block;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  max-width: 604px;
  padding-top: 34px;
  padding-bottom: 20px;
}

@media (min-width: 768px) {

  .cta-image__content {
    margin-top: -8rem;
  }

  .cta-image__content {
    padding-top: 3rem;
  }
}

@media (min-width: 1024px) {

  .cta-image__content {
    left: -1.5rem;
  }

  .cta-image__content {
    margin-left: 0px;
    margin-right: 0px;
  }

  .cta-image__content {
    margin-top: 0px;
  }

  .cta-image__content {
    padding-left: 1.5rem;
  }
}

@media (min-width: 1024px) {

.cta-image__content {
    max-width: 464px;
    padding-top: 42px;
    padding-bottom: 44px
}
  }

@media (min-width: 1200px) {

  .cta-image__content {
    left: -3rem;
  }

  .cta-image__content {
    padding-left: 3rem;
  }
}

@media (min-width: 1200px) {

.cta-image__content {
    max-width: 464px
}
  }

.cta-image__content--no-eyebrow {
    padding-bottom: 10px;
  }

@media (min-width: 1024px) {

.cta-image__content--no-eyebrow {
      padding-top: 53px;
      padding-bottom: 55px
  }
    }

@media print {

.cta-image__content {
    left: -1.5rem;
    padding-left: 1.5rem;
    max-width: 464px;
    padding-top: 42px;
    padding-bottom: 44px;
    margin: 0
}
  }

.cta-image__content .heading {
  margin-bottom: 0px;
}

.cta-image__content .heading {
  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}

.cta-image__content .heading {
  font-weight: 700;
}

.cta-image__content .heading {
  line-height: 1.1;
}

.cta-image__content .style--cta-image {
  font-size: 2.5rem;
}

.cta-image__content .style--cta-image {
  letter-spacing: -0.0625rem;
}

@media (min-width: 1024px) {

  .cta-image__content .style--cta-image {
    font-size: 2.8125rem;
  }
}

@media (min-width: 1024px) {

  .cta-image__content .style--cta-image {
    letter-spacing: -0.0425rem;
  }
}

.cta-image__eyebrow {
  margin-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}

.cta-image__button {
  padding-top: 28px;
}

@media (min-width: 768px) {

.cta-image__button {
    padding-top: 26px
}
  }

@media (min-width: 1024px) {

.cta-image__button {
    padding-top: 24px
}
  }

@media print {

.cta-image__button {
    padding-top: 24px
}
  }
`;